var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgScoreFlame = function SvgScoreFlame(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFD766",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M15 2.5c7.5 7.5-2.5 10 5 12.5l2.5-6.25c8.75 15-1.25 20-7.5 20s-13.75-5-8.75-15l3.75 5c5-5 0-8.75 5-16.25"
  })));
};
export default SvgScoreFlame;